
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 15","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.75 5.278a.75.75 0 10-1.5 0h1.5zm-1.5 4.444a.75.75 0 101.5 0h-1.5zm2.972-1.472a.75.75 0 000-1.5v1.5zm-4.444-1.5a.75.75 0 000 1.5v-1.5zM7.25 5.278V7.5h1.5V5.278h-1.5zm0 2.222v2.222h1.5V7.5h-1.5zm2.972-.75H8v1.5h2.222v-1.5zM8 6.75H5.778v1.5H8v-1.5zm5.917.75A5.917 5.917 0 018 13.417v1.5A7.417 7.417 0 0015.417 7.5h-1.5zM8 13.417A5.917 5.917 0 012.083 7.5h-1.5A7.417 7.417 0 008 14.917v-1.5zM2.083 7.5A5.917 5.917 0 018 1.583v-1.5A7.417 7.417 0 00.583 7.5h1.5zM8 1.583A5.917 5.917 0 0113.917 7.5h1.5A7.417 7.417 0 008 .083v1.5z"}})])
          )
        }
      }
    